// Bridges Flickity/Isotope onto jQuery (`.flickity()`, `.isotope()`), matching
// how the legacy app's components call them (e.g. `carousel.flickity({...})`,
// `$grid.isotope({...})`).
//
// This must be its own module, imported before any of the ported app
// components, for the same reason globals.js is split out: a plain
// `jQueryBridget('flickity', Flickity, $)` statement written directly in
// main.js would be hoisted below main.js's *other* imports (ES modules hoist
// all imports above a file's own top-level statements), including
// `./components/flickity`, which calls `.flickity()` immediately — before the
// bridge would have been registered.
import { $ } from './globals';
import Flickity from 'flickity';
import Isotope from 'isotope-layout';
import jQueryBridget from 'jquery-bridget';

jQueryBridget('flickity', Flickity, $);
jQueryBridget('isotope', Isotope, $);
